import React from "react";
import { Alert } from "react-bootstrap";

export const messageTypes = {
  ERROR_MESSAGE: "danger",
  WARNING_MESSAGE: "warning",
  SUCCESS_MESSAGE: "success",
  BASIC_MESSAGE: "light"
};

const MessageAlert = props => (
  <>
    {props.message !== null && (
      <Alert
        className={props.className}
        variant={props.messageType}
        onClose={props.onDismiss}
        dismissible
      >
        {(props.message.status || props.message.code) && (
          <Alert.Heading>
            {props.message.status}
            {`${props.message.status && props.message.code ? " - " : ""}`}
            {props.message.code}
          </Alert.Heading>
        )}
        {props.message.text}
      </Alert>
    )}
  </>
);

MessageAlert.defaultProps = {
  className: "Alert"
};

export default MessageAlert;
